import React from "react";
import { createRoot } from "react-dom/client";
import "antd/dist/reset.css";
import "./index.css";
import AppWithContext from "./AppWithContext";
// import reportWebVitals from "./reportWebVitals";

const container = document.getElementById("root");
const rootDiv = createRoot(container); // createRoot(container!) if you use TypeScript
rootDiv.render(<AppWithContext />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
